export default __webpack_public_path__ + "static/spet1-d112048aa01f09f4a9714665369f9e0b.png";